import { useEffect } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { useUpdateTaskFingerprint } from "../api";

export default () => {
  const updateFingerprint = useUpdateTaskFingerprint();
  const [params] = useSearchParams();
  useEffect(() => {
    const token = params.get("completiontoken");
    if (token) {
      updateFingerprint.mutate(token);
    }
  }, []);
  return <Outlet />;
};
